
import { Component, ViewChild, HostListener, ElementRef, AfterViewInit, OnInit } from '@angular/core';

import { LlPermissionsService } from '../ll-permissions.service';
import { LlModelsService } from '../ll-models.service';
import { LlUtilityService } from '../ll-utility.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';

@Component({
  selector: 'll-model-permissions',
  templateUrl: './ll-model-permissions.component.html',
  styleUrl: './ll-model-permissions.component.css'
})
export class LlModelPermissionsComponent {

  @ViewChild('mainDiv_ll_model_permissions') mainDiv: ElementRef;
  @ViewChild('datagrid_companies_ll_model_permissions') datagrid_companies!: jqxGridComponent;
  @ViewChild('datagrid_contacts_ll_model_permissions') datagrid_contacts!: jqxGridComponent;
  constructor(
    private LlPermissionsService: LlPermissionsService,
    private LlModelsService: LlModelsService,
    private LlUtilityService: LlUtilityService,
   
  ) { }

  bundle = {
    showHorzTabs: false,
    showRemaining: false,
    showGrid: false,
    showSelectAll: false,
    allSelected: false,
    mode: '',
    function: '',
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 40,
    remainingW: 0,
    remainingH: 0,
    gridX: 0,
    gridY: 20,
    gridW: 0,
    gridH: 200,
    grid2Y: 50,
    grid2H: 0,

    showTab: true,
    companies: [] as any[],
    contacts: [] as any[],
    
    columns_companies: [] as any[],
    columns_contacts: [] as any[],

  }

  ngOnInit() { }

  eventSubscription_ll_model_cash_switch: any;

  ngOnDestroy() {
    this.eventSubscription_ll_model_cash_switch.unsubscribe();
  }

  ngAfterViewInit() {


    this.eventSubscription_ll_model_cash_switch = this.LlModelsService.ll_model_cash_switch.subscribe(action => {
      this.bundle.mode = action;
    });

    this.setVars();
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingX = 0;
      this.bundle.remainingW = this.bundle.parentW;
      this.bundle.gridW = this.bundle.remainingW;

      this.bundle.grid2Y = this.bundle.gridY + this.bundle.gridH + 20;
      this.bundle.grid2H = this.bundle.parentH + this.bundle.grid2Y - 60;
    

     /* this.calculateGridYLocation(70);*/
      this.getData()
    });
  }

  //calculateGridYLocation(offSet) {
  //  this.bundle.remainingY = this.bundle.horzTabsY + this.bundle.hTabH + offSet
  //  this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;
  //  this.bundle.gridH = this.bundle.remainingH - 45;
  //}

  getData() {

    this.LlModelsService.NG_LL_model_company_permissions_get(
      (arr: any[]) => {
        this.bundle.companies = arr || [];
        this.paintCompanyGrid();
        this.getContactData();
      }
    );

 }

  getContactData() {

    this.bundle.showGrid = false;
    this.bundle.showSelectAll = false;


    this.LlModelsService.NG_LL_model_contact_permissions_get(
        (arr: any[]) => {
        this.bundle.contacts = arr || [];
        this.paintContactGrid();
        },
      
      );
  };



  paintCompanyGrid(): void {

    //console.log(this.bundle.records)

    if (!this.datagrid_companies) {
      console.warn('jqxGrid not ready – will retry in 100 ms');
      setTimeout(() => this.paintCompanyGrid(), 100);
      return;
    }

    var fields = [];
    var columns_companies = [];

    columns_companies.push({ text: 'Accept', datafield: 'SELECTED', columntype: 'checkbox', width: 70, editable: true, align: 'center' });
    columns_companies.push({ text: 'SysID', datafield: 'CASHFROMBANKID', columntype: 'string', width: 100, editable: false, dataType: 'string', });
    columns_companies.push({ text: 'Bank', datafield: 'BANKNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });
    columns_companies.push({ text: 'Acct No.', datafield: 'RECIPIANTIDNUMBER', columntype: 'string', width: 100, editable: true, dataType: 'string', });
    columns_companies.push({ text: 'Location', datafield: 'LOCATIONNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });


    for (let i = 0; i < columns_companies.length; i++) {
      const col = columns_companies[i];

      if (col.dataType === 'float') {
        col.cellsformat = 'f2';
        col.cellsalign = 'right';       

        fields.push({
          name: col.datafield,
          type: 'number'
        });
      } else {
        fields.push({
          name: col.datafield,
          type: 'string'
        });
      }

      function editGear(row: number, column: any, value: string) {
        var img = '<div class="editGear" [id]="EDIT" height:20px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_gear.png" ></div>';

        return img;
      }

    }

    this.bundle.columns_companies = columns_companies;

    setTimeout(() => {
      const source = { localdata: this.bundle.companies, datatype: 'array', fields };
      const dataAdapter = new jqx.dataAdapter(source);

      this.datagrid_companies.source(dataAdapter);
      this.datagrid_companies.columns(columns_companies);
      this.datagrid_companies.width(this.bundle.gridW);
      this.datagrid_companies.height(this.bundle.gridH);
      this.datagrid_companies.updatebounddata();

      this.datagrid_companies.refresh();
      this.datagrid_companies.render();

    }, 0);

    this.bundle.showGrid = true;

    function editGear(row: number, column: any, value: string) {
      var img = '<div class="editGear" [id]="EDIT" height:20px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_gear.png" ></div>';

      return img;
    }

  }

  paintContactGrid(): void {

    //console.log(this.bundle.records)

    if (!this.datagrid_companies) {
      console.warn('jqxGrid not ready – will retry in 100 ms');
      setTimeout(() => this.paintCompanyGrid(), 100);
      return;
    }

    var fields = [];
    var columns_companies = [];

    columns_companies.push({ text: 'Accept', datafield: 'SELECTED', columntype: 'checkbox', width: 70, editable: true, align: 'center' });
    columns_companies.push({ text: 'SysID', datafield: 'CASHFROMBANKID', columntype: 'string', width: 100, editable: false, dataType: 'string', });
    columns_companies.push({ text: 'Bank', datafield: 'BANKNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });
    columns_companies.push({ text: 'Acct No.', datafield: 'RECIPIANTIDNUMBER', columntype: 'string', width: 100, editable: true, dataType: 'string', });
    columns_companies.push({ text: 'Location', datafield: 'LOCATIONNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });


    for (let i = 0; i < columns_companies.length; i++) {
      const col = columns_companies[i];

      if (col.dataType === 'float') {
        col.cellsformat = 'f2';
        col.cellsalign = 'right';

        fields.push({
          name: col.datafield,
          type: 'number'
        });
      } else {
        fields.push({
          name: col.datafield,
          type: 'string'
        });
      }

      function editGear(row: number, column: any, value: string) {
        var img = '<div class="editGear" [id]="EDIT" height:20px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_gear.png" ></div>';

        return img;
      }

    }

    this.bundle.columns_companies = columns_companies;

    setTimeout(() => {
      const source = { localdata: this.bundle.companies, datatype: 'array', fields };
      const dataAdapter = new jqx.dataAdapter(source);

      this.datagrid_companies.source(dataAdapter);
      this.datagrid_companies.columns(columns_companies);
      this.datagrid_companies.width(this.bundle.gridW);
      this.datagrid_companies.height(this.bundle.gridH);
      this.datagrid_companies.updatebounddata();

      this.datagrid_companies.refresh();
      this.datagrid_companies.render();

    }, 0);

    this.bundle.showGrid = true;

    function editGear(row: number, column: any, value: string) {
      var img = '<div class="editGear" [id]="EDIT" height:20px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_gear.png" ></div>';

      return img;
    }

  }


  onCellvaluechanged(event: any): void {

    //if (this.bundle.activeCODE === "Auto-Match") {

      const rowIdx = event.args.rowindex;
      const field = event.args.datafield;
      const newVal = event.args.value;

    //}
  }

  clickOnCell_companies(event: any): void {

    console.log("clickOnRow")
    let rowIndex = event.args.rowindex;
    let dataField = event.args.datafield;
    let newValue = event.args.newvalue;

    //if (this.bundle.activeCODE === "Auto-Match") {

      if (newValue == true) {
        //this.LlModelsService.NG_LL_model_AR_cash_reconcileList_single_edit(this.bundle.records[rowIndex], 'Accept');

      } else if (newValue == false) {
        //this.LlModelsService.NG_LL_model_AR_cash_reconcileList_single_edit(this.bundle.records[rowIndex], 'Reject');
      }
    //}

 

  }

  clickOnCell_contacts(event: any): void {

    console.log("clickOnRow")
    let rowIndex = event.args.rowindex;
    let dataField = event.args.datafield;
    let newValue = event.args.newvalue;

    //if (this.bundle.activeCODE === "Auto-Match") {

    if (newValue == true) {
      //this.LlModelsService.NG_LL_model_AR_cash_reconcileList_single_edit(this.bundle.records[rowIndex], 'Accept');

    } else if (newValue == false) {
      //this.LlModelsService.NG_LL_model_AR_cash_reconcileList_single_edit(this.bundle.records[rowIndex], 'Reject');
    }
    //}



  }






  exportOnClick() {

    let label = "";

    for (let k = 0; k < this.bundle.columns_companies.length; k++) {

      this.bundle.columns_companies[k].STUDYCOLUMNQUESTIONIDALPHA = this.bundle.columns_companies[k].datafield;
      this.bundle.columns_companies[k].STUDYCOLUMNLABEL = this.bundle.columns_companies[k].text
      this.bundle.columns_companies[k].SYSTEMORGANIZATIONFIELDCODE = this.bundle.columns_companies[k].datafield
    }

    var rows = this.datagrid_companies.getdisplayrows();

    this.LlUtilityService.saveCSV(rows, this.bundle.columns_companies, label)

  };

}
